import { CrossIcon } from "../../../../../shared/svg/cross-icon";

interface ModalHeaderProps {
  title: string;
  onClose: () => void;
}

const ModalHeader = ({ title, onClose }: ModalHeaderProps) => {
  return (
    <div className="flex items-center justify-between border-b border-[#e5e7eb] px-6 py-5">
      <h2 className="m-0 font-['Lato'] text-lg font-bold leading-[1.625rem]">
        {title}
      </h2>
      <button
        className="flex cursor-pointer items-center justify-center border-none bg-transparent p-1 hover:opacity-70"
        onClick={onClose}
      >
        <CrossIcon fillColor="#374151" />
      </button>
    </div>
  );
};

export default ModalHeader;
